module.exports = __webpack_public_path__ + "img/close-blue.83119e02.svg";